module.exports = __webpack_public_path__ + "static/img/cherrylemonadebublyburst_th.8bfc601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/cherrylemonadebublyburst_th.png
// module id = IUjD
// module chunks = 0